module.exports = {
    RESOURCE_GROUP_ID: 'e8a5c0d6-81ad-4c06-a16a-000e528ee6d3',
    RESOURCE_GROUP_NAME: 'GRP_EAD_APP_TRANSACCIONAL'
}